import React, { Fragment } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

const SnackBar = () => {
  return (
    <Fragment>
        <ToastContainer />
    </Fragment>
  )
}

export default SnackBar